import domReady from '@wordpress/dom-ready';

domReady(() => {
  const faders = document.querySelectorAll('.fade-up');

  const options = {
    threshold: 0.2,
  };

  const appearOnScroll = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      }
    });
  }, options);
  if (faders) {
    faders.forEach((fader) => {
      appearOnScroll.observe(fader);
    });
  }
});
